<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">

        <div class="search-filters">
          <div v-hasRole="['common']" style="margin-right: 30px;">
            企业名称
            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
          </div>
          <div>
            测试牌照
            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
          </div>
          <div class="ml30" v-hasRole="['carEnterprise']">
            车架号
            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.frameNum"></a-input>
          </div>

          <!-- 新增：更多操作按钮 -->
          <a-button class="ml30" @click="showMoreFilters = !showMoreFilters" type="primary" ghost>
            {{ showMoreFilters ? '收起' : '更多' }}
          </a-button>

          <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
          <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
          <div></div>
        </div>
        <div v-if="showMoreFilters" class="search-filters">
          <div>
            车辆状态
            <a-select class="inp ml24" placeholder="请选择" v-model:value="query.carStatus">
              <a-select-option value="0">正常</a-select-option>
              <a-select-option value="1">异常</a-select-option>
              <a-select-option value="2">维护中</a-select-option>
            </a-select>
          </div>
          <div class="ml30">
            自动驾驶级别
            <a-select class="inp ml24" placeholder="请选择" v-model:value="query.dynamicDriverLevel">
              <a-select-option value="1">L1</a-select-option>
              <a-select-option value="2">L2</a-select-option>
              <a-select-option value="3">L3</a-select-option>
              <a-select-option value="4">L4</a-select-option>
              <a-select-option value="5">L5</a-select-option>
            </a-select>
          </div>
          <div class="ml30">
            监管装置状态
            <a-select class="inp ml24" placeholder="请选择" v-model:value="query.bindMonitorDevice">
              <a-select-option value="0">未安装</a-select-option>
              <a-select-option value="1">已安装</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="search-r">

      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id"
             :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }">
      <template #bodyCell="{ column, record, index }">

        <template v-if="column.key === 'index'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'testCarNum'">
          {{ record.testCarNum }}
          <div style="color:red;font-size:12px" v-if="record.plateExpireWarn">{{ record.plateExpireWarn }}</div>
        </template>
        <template v-if="column.key === 'carType'">
          {{ getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + record.carType) }}
        </template>
        <template v-if="column.key === 'carColor'">
          {{ getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'fuselageColor' + record.carColor) }}
        </template>

        <template v-else-if="column.key === 'action'">
          <span>
            <a @click="detail(record)">详情</a>
            <a v-if="store.hasPermi('car:update:apply')" class="ml10" v-hasRole="['carEnterprise']">信息变更申请</a>
          </span>
        </template>
      </template>
    </a-table>

  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getCars } from "@/api/car/car.js";
import moment from "moment";
import useUserStore from '@/store/modules/user'
import { getSingleTypeValue } from "@/utils/matchDic.js";

const router = useRouter();
const store = useUserStore();
const route = useRoute();

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    fixed: 'left',
    width: 90
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
  },
  {
    title: "测试牌照",
    dataIndex: "testCarNum",
    key: "testCarNum",
    width: 116,
  },
  {
    title: "车辆类型",
    key: "carType",
    dataIndex: "carType",
  },
  {
    title: "自动驾驶级别",
    key: "dynamicDriverLevel",
    dataIndex: "dynamicDriverLevel",
    width: 126,
  },
  {
    title: "车架号",
    key: "frameNum",
    dataIndex: "frameNum",
    width: 180,
  },
  {
    title: "车辆颜色",
    key: "carColor",
    dataIndex: "carColor",
  },
  {
    title: "车辆状态",
    key: "carStatus",
    dataIndex: "carStatus",
  },
  {
    title: "车辆品牌",
    key: "carBrand",
    dataIndex: "carBrand",
  },
  {
    title: "车辆型号",
    key: "carModel",
    dataIndex: "carModel",
  },
  {
    title: "耗能类型",
    key: "energyType",
    dataIndex: "energyType",
  },
  {
    title: "最大容量",
    key: "maxCapacity",
    dataIndex: "maxCapacity",
  },
  {
    title: "监管装置",
    key: "bindMonitorDevice",
    dataIndex: "bindMonitorDevice",
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "操作",
    key: "action",
    fixed: 'right',
    width: 120,
  },
];

let dataSource = ref([]);
// 新增控制更多筛选条件显示/隐藏的状态
const showMoreFilters = ref(false);
let query = reactive({
  deptName: "",
  frameNum: "",
  testCarNum: "",
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.deptName = "";
  query.frameNum = "";
  query.testCarNum = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  console.log(store.deptId, 12454)
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptIdStr: store.deptId },
  };
  getCars(data).then((res) => {
    res.data.records.map((item, index) => {
      item.status = item.status === 1 ? true : false;
    });
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

onMounted(async () => {
  //getData();
  // 获取路由参数
  const testCarNum = route.query.testCarNum;
  if (testCarNum){
    query.testCarNum = testCarNum;
  }
  getData();
});

const detail = (record) => {
  console.log(record);
  router.push({
    path: "/carManage/carDetail",
    query: { id: record.id }
  });
};

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    align-items: center;
  }

  .search-r {
    display: flex;
    align-items: center;
  }
}

.search-filters {
  display: flex;
  padding: 12px;
  border-radius: 4px;
  flex-wrap: wrap;
  align-items: center;
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767e;
}

/deep/.ant-select-selector {
  background-color: #f2f4f7 !important;
  color: #68767e !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

/deep/.ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody>tr>td {
  height: 90px;
}

a {
  color: #1E8EF2;
}
</style>
@/api/car/car.js